import {
  ActionSheet,
  ActionSheetButton,
  ShowActionsOptions,
  ShowActionsResult,
} from '@capacitor/action-sheet';
import { ActionSheetController } from '@ionic/angular';
import { ActionSheetOptions } from '@ionic/core/dist/types/components/action-sheet/action-sheet-interface';
import { Capacitor } from '@capacitor/core';
import { Injectable, inject } from '@angular/core';

export type ProtoActionSheetButton = ActionSheetButton & {
  id?: string;
};

export type ProtoActionsOptions = {
  title?: string; // title is optional too, which gives us more flexibility
  message?: string;
  options: ProtoActionSheetButton[];
};

@Injectable({
  providedIn: 'root',
})
export class ActionSheetService {
  private actionSheetController = inject(ActionSheetController);

  // return index of selected option

  public async show(config: ProtoActionsOptions): Promise<number> {
    if (Capacitor.isNativePlatform()) {
      config.title = config.title || ''; // `ShowActionsOptions` title is required
      const result: ShowActionsResult = await ActionSheet.showActions(config as ShowActionsOptions);

      return Promise.resolve(result.index);
    }

    let selectedIndex: number = config.options.length - 1;
    const pwaConfig: ActionSheetOptions = {
      buttons: config.options
        .map((option, index) => {
          let role: string = '';

          if (option.style) {
            role = option.style as string;
          }

          return {
            handler: (): void => {
              selectedIndex = index;
            },
            role: role.toLowerCase(),
            text: option.title,
          };
        }),
    };

    if (config.title) {
      pwaConfig.header = config.title;
    }

    if (config.message) {
      pwaConfig.subHeader = config.message;
    }

    const actionsheet = await this.actionSheetController.create(pwaConfig);

    await actionsheet.present();
    await actionsheet.onWillDismiss();

    return Promise.resolve(selectedIndex);
  }
}
